module.exports = __webpack_public_path__ + "img/Conflict Confronter.734cbedd.svg";